import cloneDeep from 'lodash/cloneDeep';
import {
  updateData,
  updateSupportData,
  jump,
  randomAccessJump,
  DO_BACKUP,
} from '../../../AdvWorkflow/AdvWorkflowActions';
import { ITERATOR_POST_END } from '../../../AdvWorkflow/AdvWorkflowHelpers';

export const getDesiredPurchaseYear = (largePurchaseGoal) => {
  if (largePurchaseGoal.PurchaseAtRetirement) {
    return 'At Retirement';
  }
  return `${largePurchaseGoal.DesiredPurchaseYear}`;
};

const clearStagedGoal = (operation, workflowId, clientId, dispatch) => {
  // update to null and {} because the
  // framework will merge if we update directly to {}.
  const dataSequence = [null, {}];
  dataSequence.forEach((element) => {
    dispatch(operation(
      {
        LargePurchaseGoal: element,
      },
      workflowId,
      clientId,
    ));
  });
};

export const onAddNewGoal = (workflowId, clientId) => (dispatch) => {
  clearStagedGoal(updateData, workflowId, clientId, dispatch);
  clearStagedGoal(updateSupportData, workflowId, clientId, dispatch);
  dispatch(updateSupportData(
    {
      BlockAutoOutput: false,
    },
    workflowId,
    clientId,
  ));
  dispatch(jump(1, workflowId, clientId));
};

export const onGoalEdit = (largePurchaseGoal, workflowId, clientId) => (dispatch) => {
  dispatch(updateSupportData(
    {
      LargePurchaseGoal: {
        ...cloneDeep(largePurchaseGoal),
      },
      BlockAutoOutput: true,
    },
    workflowId,
    clientId,
  ));
  dispatch(randomAccessJump(workflowId, clientId, ITERATOR_POST_END));
};

export const onGoalDelete = (
  goalId,
  largePurchaseGoals,
  workflowId,
  clientId,
) => async (dispatch) => {
  const {
    ADV: {
      util: { request },
    },
  } = window;

  const response = await request({
    uri: 'Consumer/GoalUpdate/Delete',
    type: 'POST',
    data: {
      clientId,
      goalId,
    },
  });

  if (response.success) {
    dispatch(updateData(
      {
        LargePurchaseGoals: largePurchaseGoals.filter(({ Id }) => Id !== goalId),
      },
      workflowId,
      clientId,
    ));
    dispatch({
      type: DO_BACKUP,
      workflowId,
      clientId,
    });
  }
};
